<template>
  <div class="Home">
    <div class="logo"></div>
    <div class="redian">
      <div class="title">主打产品</div>
      <div class="redian1"></div>
      <div class="redian2"></div>
    </div>

    <div class="redian" style="left: 13rem; bottom: 8.3rem">
      <div class="title" style="bottom: 0.8rem; right: 0.8rem">保健类产品</div>
      <div class="redian1"></div>
      <div class="redian2"></div>
    </div>

    <div class="redian" style="left: 18.9rem; bottom: 9.3rem">
      <div class="title" style="bottom: 1rem; right: -1.1rem">冲饮类产品</div>
      <div class="redian1"></div>
      <div class="redian2"></div>
    </div>

    <div class="redian" style="left: 25.2rem; bottom: 8rem">
      <div class="title" style="bottom: 0.6rem; left: 1rem">营养奶粉</div>
      <div class="redian1"></div>
      <div class="redian2"></div>
    </div>

    <div class="redian" style="left: 29.6rem; bottom: 5.6rem">
      <div class="title" style="bottom: 0.2rem; left: 1rem">休闲产品</div>
      <div class="redian1"></div>
      <div class="redian2"></div>
    </div>

    <div class="bt1">
      <img :src="bt1img" alt="" />

      <router-link :to="{ path: '/ProductList', query: { cid: 1 } }">
        <div class="icon1"></div>
      </router-link>

      <router-link :to="{ path: '/ProductList', query: { cid: 2 } }">
        <div class="icon2"></div>
      </router-link>
      <router-link :to="{ path: '/ProductList', query: { cid: 3 } }">
        <div class="icon3"></div>
      </router-link>
      <router-link :to="{ path: '/ProductList', query: { cid: 4 } }">
        <div class="icon4"></div>
      </router-link>
      <router-link :to="{ path: '/ProductList', query: { cid: 5 } }">
        <div class="icon5"></div>
      </router-link>
      <div class="bt2"></div>
    </div>
  </div>
</template>

<script>
import { Catelist } from '@/api/Home'
export default {
  data() {
    return {
      msg: '',

      list: [],
      bt1img: './static/images/Home/bt1.png',
    }
  },
  created() {
    this.getdata()
  },
  mounted() {},

  methods: {
    async getdata() {
      const { data: res } = await Catelist()
      if (res.code === 1) {
        this.list = res.data
      }
    },
  },
}
</script>

<style lang="less" scoped>
.Home {
  position: absolute;
  // width: 38.4rem;
  // height: 21.6rem;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: url('../../static/images/Home/bg.png') no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  min-width: 32.29rem;
  .logo {
    position: absolute;
    top: 1.86rem;
    width: 11.6rem;
    height: 4.56rem;
    left: 50%;
    transform: translateX(-50%);
    background: url('../../static/images/Home/logo.png') no-repeat;
    background-size: 100% 100%;
  }
  .redian {
    position: absolute;
    width: 0.8rem;
    height: 0.8rem;
    left: 7.24rem;
    bottom: 5.1rem;
    .title {
      z-index: 9999;
      position: absolute;
      width: 3rem;
      bottom: 0.5rem;
      right: 0.5rem;
      // height: 59px;
      font-size: 0.6rem;
      font-family: OPPOSans;
      font-weight: 500;
      color: #333333;
    }
    // background: red;
    // animation: move 2s linear infinite;
    .redian1 {
      position: absolute;
      z-index: 9999;
      top: 50%;
      left: 50%;
      border-radius: 50%;
      transform: translate(-50%, -50%);
      width: 0.42rem;
      height: 0.42rem;
      background: #fff;
    }
    .redian2 {
      position: absolute;
      z-index: 9998;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      // left: 7.24rem;
      // bottom: 5rem;
      width: 0.42rem;
      height: 0.42rem;
      border-radius: 50%;
      background: #597e07;
      opacity: 0.3;
      border-radius: 50%;
      animation: move 1.5s linear infinite;
    }
  }

  @keyframes move {
    0% {
      width: 0;
      height: 0;
    }
    10% {
      width: 0.42rem;
      height: 0.42rem;
      opacity: 0.1;
    }
    50% {
      width: 0.52rem;
      height: 0.52rem;
      opacity: 0.3;
    }
    100% {
      width: 0.7rem;
      height: 0.7rem;
      opacity: 0.3;
    }
  }
  .bt1 {
    position: absolute;
    width: 32.29rem;
    height: 9.78rem;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    .bt2 {
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      width: 9.5rem;
      height: 1.66rem;
      background: url('../../static/images/Home/bt2.png') no-repeat;
      background-size: 100%;
      // background: red;
    }

    // background: url('../../static/images/Home/bt1.png') no-repeat;
    // background-size: 100%;
    .icon1 {
      position: absolute;
      z-index: 9999;
      left: 7.24rem;
      bottom: 1.3rem;
      width: 1.22rem;
      height: 1.18rem;
      // background: red;
      background: url('../../static/images/Home/1.png') no-repeat;
      background-size: 100%;
      &:hover {
      }
    }
    .icon2 {
      position: absolute;
      z-index: 9999;
      left: 11.56rem;
      bottom: 2.97rem;
      width: 1.21rem;
      height: 1.35rem;
      // background: red;
      background: url('../../static/images/Home/2.png') no-repeat;
      background-size: 100%;
    }
    .icon3 {
      position: absolute;
      z-index: 9999;
      left: 15.7rem;
      bottom: 3.84rem;
      width: 1.2rem;
      height: 1.07rem;
      // background: red;
      background: url('../../static/images/Home/3.png') no-repeat;
      background-size: 100%;
    }
    .icon4 {
      position: absolute;
      z-index: 9999;
      left: 19.63rem;
      bottom: 2.84rem;
      width: 1.09rem;
      height: 1.33rem;
      // background: red;
      background: url('../../static/images/Home/4.png') no-repeat;
      background-size: 100%;
    }
    .icon5 {
      position: absolute;
      z-index: 9999;
      left: 23.36rem;
      bottom: 1.03rem;
      width: 1.29rem;
      height: 1.25rem;
      // background: red;
      background: url('../../static/images/Home/5.png') no-repeat;
      background-size: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue